var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("page-title-area", [_c("h1", [_vm._v(_vm._s(_vm.placeName))])]),
      _vm._v(" "),
      !_vm.loading && _vm.placeSensors.length === 0
        ? _c(
            "v-card",
            { attrs: { outlined: "" } },
            [
              _c("v-card-text", [
                _vm._v(_vm._s(_vm.$mpt(_vm.$t("msg.no_sensors")))),
              ]),
            ],
            1
          )
        : [
            _c(
              "v-card",
              { staticClass: "mb-5", attrs: { outlined: "" } },
              [
                _c(
                  "v-card-text",
                  {
                    staticClass: "d-flex align-center flex-wrap",
                    staticStyle: { gap: "16px" },
                  },
                  [
                    _c("div", { staticClass: "control-group" }, [
                      _c("span", { staticClass: "control-group__label" }, [
                        _vm._v(_vm._s(_vm.$t("label.display_month"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "d-inline-block compact-select",
                          staticStyle: { width: "90px" },
                        },
                        [
                          _c("month-field", {
                            attrs: {
                              value: _vm.month,
                              "max-date": _vm.currentMonth,
                              dense: "",
                              outlined: "",
                              "hide-details": "",
                              "data-testid": "month-selector",
                            },
                            on: {
                              input: function ($event) {
                                _vm.month = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "control-group" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "control-group__label d-inline-flex align-baseline",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$mpt(_vm.$t("label.sensor"))) +
                                "\n            "
                            ),
                            _vm.hasRatSenseSensor
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "", "max-width": "300" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass: "ml-1",
                                                      attrs: {
                                                        "x-small": "",
                                                        "aria-label":
                                                          _vm.ratSenseNotice,
                                                        "data-testid":
                                                          "rat-sense-notice-icon",
                                                      },
                                                    },
                                                    "v-icon",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    "\n                  mdi-information-outline\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3900783698
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.ratSenseNotice)),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-select", {
                          staticClass: "small-select",
                          staticStyle: { "max-width": "160px" },
                          attrs: {
                            items: _vm.sensorOptions,
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                            "data-testid": "sensor-select",
                          },
                          model: {
                            value: _vm.selectedSensorId,
                            callback: function ($$v) {
                              _vm.selectedSensorId = $$v
                            },
                            expression: "selectedSensorId",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "control-group" },
                      [
                        _c("span", { staticClass: "control-group__label" }, [
                          _vm._v(_vm._s(_vm.$t("label.detection_type"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-btn-toggle",
                          {
                            attrs: {
                              mandatory: "",
                              dense: "",
                              color: "primary",
                            },
                            model: {
                              value: _vm.filterMode,
                              callback: function ($$v) {
                                _vm.filterMode = $$v
                              },
                              expression: "filterMode",
                            },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  value: "exclude_misdetection",
                                  small: "",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("filter.exclude_misdetection"))
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              { attrs: { value: "pickup_only", small: "" } },
                              [_vm._v(_vm._s(_vm.$t("filter.pickup_only")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              { attrs: { value: "all", small: "" } },
                              [_vm._v(_vm._s(_vm.$t("filter.all")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-spacer"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "control-group" },
                      [
                        _c("span", { staticClass: "control-group__label" }, [
                          _vm._v(" "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              loading: _vm.exporting,
                              disabled: _vm.exporting || _vm.loading,
                              "aria-label": _vm.$t("action.download"),
                              "data-testid": "download-detection-trend",
                            },
                            on: { click: _vm.handleExportImage },
                          },
                          [_c("v-icon", [_vm._v("mdi-download")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { ref: "exportContainer" },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.exporting,
                        expression: "exporting",
                      },
                    ],
                    staticClass: "detection-trend-export-info",
                    attrs: { "data-testid": "detection-trend-export-info" },
                  },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("export_info.facility")) +
                          ": " +
                          _vm._s(_vm.placeName)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$mpt(_vm.$t("label.sensor"))) +
                          ": " +
                          _vm._s(_vm.selectedSensorLabel)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("export_info.period")) +
                          ": " +
                          _vm._s(_vm.month)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("label.detection_type")) +
                          ": " +
                          _vm._s(_vm.filterModeLabel)
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-card",
                  { attrs: { outlined: "" } },
                  [
                    _vm.featureIsActive("r_type_capture_record") &&
                    _vm.captureRecords.length > 0
                      ? _c("div", { staticClass: "chart-legend pa-4 pb-0" }, [
                          _c("span", { staticClass: "legend-item" }, [
                            _c("span", {
                              staticClass: "legend-line",
                              style: { borderTopColor: _vm.primaryColor },
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("legend.detection_count")) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "legend-item" }, [
                            _c("span", {
                              staticClass: "legend-bar",
                              style: {
                                backgroundColor: _vm.captureRecordColor,
                                borderColor: _vm.captureRecordBorderColor,
                              },
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("legend.capture_count")) +
                                "\n          "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-card-text",
                      {
                        staticStyle: { position: "relative" },
                        attrs: { "data-testid": "detection-trend-chart" },
                      },
                      [
                        _c(
                          "v-overlay",
                          { attrs: { value: _vm.loading, absolute: "" } },
                          [_c("page-load-spinner")],
                          1
                        ),
                        _vm._v(" "),
                        _c("line-chart", {
                          attrs: {
                            data: _vm.chartData,
                            options: _vm.chartOptions,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.featureIsActive("r_type_capture_record")
              ? _c(
                  "v-card",
                  {
                    staticClass: "capture-records-section mt-6",
                    attrs: { outlined: "" },
                  },
                  [
                    _c(
                      "v-card-title",
                      { staticClass: "d-flex align-center" },
                      [
                        _c("span", { staticClass: "capture-card-title" }, [
                          _vm._v(_vm._s(_vm.$t("capture_records.title"))),
                        ]),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              small: "",
                              color: "primary",
                              "data-testid": "add_capture_record_button",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openCaptureRecordEditor()
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { left: "", small: "" } }, [
                              _vm._v("add"),
                            ]),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("capture_records.add")) +
                                "\n        "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-divider"),
                    _vm._v(" "),
                    _c("v-data-table", {
                      attrs: {
                        items: _vm.filteredCaptureRecords,
                        headers: _vm.captureRecordHeaders,
                        "no-data-text": _vm.$t("capture_records.no_data"),
                        "hide-default-footer": "",
                        "items-per-page": _vm.captureRecordsPerPage,
                        page: _vm.captureRecordPage,
                        "sort-by": ["date"],
                        "data-testid": "capture_records_table",
                      },
                      on: {
                        "update:page": function ($event) {
                          _vm.captureRecordPage = $event
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item.date",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.formatCaptureDate(item.date)) +
                                    "\n        "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.species",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.speciesDisplayName(item.species)
                                    ) +
                                    "\n        "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.sensor_names",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                !item.sensor_ids || item.sensor_ids.length === 0
                                  ? _c("span", [_vm._v("-")])
                                  : _vm._l(
                                      item.sensor_ids || [],
                                      function (id) {
                                        return _c(
                                          "span",
                                          {
                                            key: id,
                                            staticClass: "sensor-tag",
                                          },
                                          [_vm._v(_vm._s(_vm.sensorName(id)))]
                                        )
                                      }
                                    ),
                              ]
                            },
                          },
                          {
                            key: "item.memo",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "memo-cell",
                                    attrs: { title: item.memo },
                                  },
                                  [_vm._v(_vm._s(item.memo))]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.actions",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-menu",
                                  {
                                    attrs: { "offset-y": "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        "data-testid":
                                                          "capture_record_menu_" +
                                                          item.id,
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { small: "" } },
                                                    [
                                                      _vm._v(
                                                        "mdi-dots-vertical"
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "v-list",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "v-list-item",
                                          {
                                            attrs: {
                                              "data-testid":
                                                "edit_capture_record_" +
                                                item.id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openCaptureRecordEditor(
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(_vm.$t("action.edit"))
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item",
                                          {
                                            attrs: {
                                              "data-testid":
                                                "delete_capture_record_" +
                                                item.id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.confirmDeleteCaptureRecord(
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(_vm.$t("action.delete"))
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        905510714
                      ),
                    }),
                    _vm._v(" "),
                    _vm.captureRecordPageCount > 1
                      ? _c("v-pagination", {
                          staticClass: "mt-2 ml-3",
                          attrs: {
                            length: _vm.captureRecordPageCount,
                            color: "grey",
                            "data-testid": "capture_records_pagination",
                          },
                          model: {
                            value: _vm.captureRecordPage,
                            callback: function ($$v) {
                              _vm.captureRecordPage = $$v
                            },
                            expression: "captureRecordPage",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.featureIsActive("r_type_capture_record")
              ? _c("capture-record-editor", {
                  attrs: {
                    record: _vm.captureRecordEditTarget,
                    sensors: _vm.captureRecordEditorSensors,
                    "place-id": _vm.placeId,
                  },
                  on: { saved: _vm.onCaptureRecordSaved },
                  model: {
                    value: _vm.captureRecordEditorVisible,
                    callback: function ($$v) {
                      _vm.captureRecordEditorVisible = $$v
                    },
                    expression: "captureRecordEditorVisible",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.featureIsActive("r_type_capture_record")
              ? _c("confirm-dialog", {
                  attrs: { message: _vm.$t("capture_records.delete_confirm") },
                  on: { yes: _vm.deleteCaptureRecord },
                  model: {
                    value: _vm.captureRecordDeleteVisible,
                    callback: function ($$v) {
                      _vm.captureRecordDeleteVisible = $$v
                    },
                    expression: "captureRecordDeleteVisible",
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }